export default "/assets/images/app-update-img-05.webp?5beb7a9fcccb4122902fba1ed161beed";